/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_Placeholder_ClientInputs */

const cs_entity_picker_placeholder_client = /** @type {(inputs: Entity_Picker_Placeholder_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat klienta (jméno, e-mail, telefon)`)
};

const en_entity_picker_placeholder_client = /** @type {(inputs: Entity_Picker_Placeholder_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search client (name, email, phone)`)
};

/**
* | output |
* | --- |
* | "Search client (name, email, phone)" |
*
* @param {Entity_Picker_Placeholder_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_placeholder_client = /** @type {((inputs?: Entity_Picker_Placeholder_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_Placeholder_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_placeholder_client(inputs)
	return cs_entity_picker_placeholder_client(inputs)
});